module.exports = __webpack_public_path__ + "img/icon_menu_sp_sagyou.7ec0902b.png";